import { useMemo } from 'react';
import { useAppContext } from 'src/AppContextProvider';
import { useLocalStorage } from 'src/domain/useLocalStorage';
import { PJM_REGISTRATION_PAGE_CONST } from './constants';

export const usePjmRegistrationsSidebar = () => {
    const { isFiltersSidebarEnabled } = useAppContext();

    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(PJM_REGISTRATION_PAGE_CONST.localStorage.sidebarCollapsedKey, false);

    const layoutPaddingLeft = useMemo(() => {
        if (!isFiltersSidebarEnabled) return '0';

        return sidebarCollapsed ? '35px' : '200px';
    }, [isFiltersSidebarEnabled, sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
        isFiltersSidebarEnabled,
    };
};
